import { atom } from 'recoil';

export enum PopupType {
    RetouchingExamples = 'retoching-examples'
}

export const popupOpenState = atom<boolean>({
    key: 'popupOpenState',
    default: false
});

export const popupTypeState = atom<PopupType | null>({
    key: 'popupTypeState',
    default: null
});
